(function() {
	// globals
	PM.Config = {};

	// app functions

	/**
	 * Render the sidebar wrapper and inject section content.
	 * @param {string} activeSection - 'colors' or 'organization'
	 * @param {string} contentHtml - the section-specific HTML to inject
	 */
	PM.Config.renderSection = function(activeSection, contentHtml) {
		var sidebarLink = 'config-' + activeSection.replace(/\//g, '-');
		PM.Shell.setSidebarActive(sidebarLink);

		var sectionLabel = i18next.t('Configuration');
		if (activeSection === 'organization') sectionLabel = i18next.t('Organization');
		else if (activeSection === 'roles') sectionLabel = i18next.t('Roles');
		else if (activeSection === 'colors') sectionLabel = i18next.t('Plan Colors');
		else if (activeSection && activeSection.startsWith('integrations')) sectionLabel = i18next.t('Integrations');
		PM.Shell.setBreadcrumb([
			{ label: i18next.t('Config') },
			{ label: sectionLabel }
		]);
		$('.js-page-container').html(contentHtml);
	};

	// app startup

	// Redirect /config to /config/organization
	page('/config', PM.Shell.routeWithPermission('view_organization', function() {
		page.redirect('/config/organization');
	}));
})();
